import { render, staticRenderFns } from "./ExamenPaginado.vue?vue&type=template&id=10052332&"
import script from "./ExamenPaginado.vue?vue&type=script&lang=js&"
export * from "./ExamenPaginado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports